// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__AFgS6","footer":"ModalFilter_footer__2zpd1"};